export const WHITE_LABEL_UNDERWRITER = "underwriterservicesassoc";
export const WHITE_LABEL_ADP = "adp-partnership";
export const WHITE_LABEL_VELOCITY_GLOBAL = "velocity-global";
